import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { ComissionBreakdown, ComissionProps } from './ComissionBreakdown'
import { useContainerWidth, useSelector } from 'src/hooks'
import { GradientText } from './StyledText'

export type BonusInfoModalProps = {
  title: string
  description: string
  onClose?: () => void
} & Omit<ComissionProps, 'isMobile'>

export const BonusInfoModal = (props: BonusInfoModalProps) => {
  const { title, description, onClose, ...rest } = props
  const [containerRef, containerWidth] = useContainerWidth()
  const screenWidth = useSelector(state => state.window.width)
  const isSmallMobile = screenWidth <= 428

  const shouldStack = containerWidth < 567

  const montserratFont = 'Montserrat, san serif'

  const gradientText = {
    background: 'linear-gradient(74deg, #34E3DF 16.27%, #02AEEE 86.38%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  }

  return (
    <Div
      ref={containerRef}
      position="relative"
      flexDirection={shouldStack ? 'column' : 'row'}
      width="100%"
      rowGap="x2"
      display="flex"
      justifyContent={shouldStack ? 'initial' : 'space-between'}
      inset="x4"
      alignItems="center"
      style={{
        borderRadius: '.5rem',
        background: '#fff',
        boxShadow:
          '0px 0px 12px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(25, 234, 183, 0.10)',
        backdropFilter: 'blur(16px)',
      }}
    >
      <Div
        onClick={onClose}
        width="fit-content"
        height="fit-content"
        position="absolute"
        cursor="pointer"
        top={shouldStack ? '3px' : '0px'}
        right={shouldStack ? '20px' : undefined}
        style={{
          fontSize: '1.5rem',
          fontWeight: 600,
          fontFamily: montserratFont,
          ...gradientText,
        }}
      >
        x
      </Div>
      <Flex flexDirection="column" rowGap="x1_5" inset={{ right: 'x2' }}>
        <GradientText color={gradientText.background} fontSize="1.125rem">
          {title}
        </GradientText>
        <Text
          type="body"
          content={description}
          style={{
            fontFamily: montserratFont,
            fontSize: isSmallMobile ? '.75rem' : '.825rem',
            color: '#6B7280',
          }}
          lineHeight={1.2}
        />
      </Flex>
      <ComissionBreakdown isMobile={shouldStack} {...rest} />
    </Div>
  )
}
